var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9976 10.9971V18.9971",
    stroke: "#718EBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99741 12.8963C2.25445 12.1373 1.69398 11.219 1.35844 10.2113C1.02291 9.2035 0.921116 8.13258 1.06077 7.07964C1.20042 6.02669 1.57787 5.01934 2.1645 4.13387C2.75114 3.2484 3.53159 2.50805 4.44674 1.96889C5.36189 1.42972 6.38774 1.10589 7.44658 1.02191C8.50542 0.937937 9.56948 1.09602 10.5582 1.48419C11.5469 1.87237 12.4343 2.48045 13.1531 3.26237C13.872 4.0443 14.4035 4.97957 14.7074 5.99733H16.4974C17.4629 5.99722 18.4029 6.30766 19.1784 6.88277C19.9539 7.45789 20.5239 8.2672 20.8042 9.19114C21.0844 10.1151 21.0601 11.1047 20.7347 12.0137C20.4094 12.9228 19.8003 13.703 18.9974 14.2393",
    stroke: "#718EBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99756 14.9971L10.9976 10.9971L14.9976 14.9971",
    stroke: "#718EBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.61130323cfa9025c60a5c810d38fd7ef.svg";
export { ForwardRef as ReactComponent };